import { EnumSentFaxStatus } from "@/Common/Models/Faxing/EnumSentFaxStatus";
import { SentFaxUiStatus } from "@/Common/Models/UI/SentFaxUiStatus";
import { SentFaxInfo } from "@/Patient/Models/Fax/SentFaxInfo";

class SentFaxStatusHelper {
    /**
     * Convert a fax status to its simplified UI status.
     * @param status The fax status to convert.
     */
    public static convertToUiStatus(status: EnumSentFaxStatus): SentFaxUiStatus {
        switch (status) {
            case EnumSentFaxStatus.Sent:
                return SentFaxUiStatus.Sent;

            case EnumSentFaxStatus.InProgress:
            case EnumSentFaxStatus.SendingEmail:
            case EnumSentFaxStatus.Queued:
                return SentFaxUiStatus.InProgress;

            default:
                return SentFaxUiStatus.Failed;
        }
    }

    /**
     * Get the overall UI status for a set of sent fax statuses.
     * @param statuses The status of each sent fax for which to get an overall UI status.
     */
    public static getOverallStatus(statuses: EnumSentFaxStatus[]): SentFaxUiStatus {
        const uiStatuses = statuses.map(p => SentFaxStatusHelper.convertToUiStatus(p));

        if (uiStatuses.includes(SentFaxUiStatus.Failed) && uiStatuses.any(status => status != SentFaxUiStatus.Failed))
            return SentFaxUiStatus.Error;

        return uiStatuses.sort().firstOrDefault();
    }

    /**
     * Get the most recent fax that failed to send.
     * @param sentFaxes The sent faxes to filter.
     */
    public static getLastFailedSentFaxId(sentFaxes: SentFaxInfo[]): number | null {
        const lastFailedFax = sentFaxes.firstOrDefault(fax => SentFaxStatusHelper.convertToUiStatus(fax.SentStatus) === SentFaxUiStatus.Failed);

        return lastFailedFax?.Id;
    }
}

export { SentFaxStatusHelper };
